import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetUserWalletAmount = async (userID) => {
    const url = `${BaseUrl}/UserWallet/GetUserWalletAmount?UserID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetWalletTransactionList = async (userID) => {
    const url = `${BaseUrl}/UserWallet/GetWalletTransactionList?UserID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetUserReferencedList = async (userID) => {
    const url = `${BaseUrl}/UserWallet/GetUserReferencedList?UserID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
